import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { resolveImage } from "../lib/api";

export default function ClassicCard({ item, index = 0 }) {
  const { lang, t } = useI18n();
  const short = lang === "nl" ? item.short_nl : item.short_en;
  const img = resolveImage(item.image_url);

  return (
    <Link
      to={`/klassiekers/${item.slug}`}
      data-testid={`classic-card-${item.slug}`}
      className="stoel-card group"
      style={{ animationDelay: `${(index % 6) * 40}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-stoel-paperDeep">
        <img
          src={img}
          alt={item.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
          onError={(e) => {
            e.currentTarget.src = resolveImage(null);
          }}
        />
        {item.featured && (
          <span
            data-testid="featured-badge"
            className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.25em] text-stoel-paper bg-stoel-terracotta px-2 py-1"
          >
            {lang === "nl" ? "Selectie" : "Selection"}
          </span>
        )}
      </div>
      <div className="pt-5 pb-2 space-y-1.5">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-base md:text-lg font-medium text-stoel-ink leading-snug">
            {item.name}
          </h3>
          {item.year && (
            <span className="text-xs text-stoel-inkSoft tabular-nums">
              {item.year}
            </span>
          )}
        </div>
        <p className="text-xs uppercase tracking-[0.18em] text-stoel-walnut">
          {item.designer}
          {item.brand ? ` · ${item.brand}` : ""}
        </p>
        {short && (
          <p className="text-sm text-stoel-inkSoft leading-relaxed line-clamp-2 pt-1">
            {short}
          </p>
        )}
      </div>
    </Link>
  );
}
